import { useTranslation } from 'react-i18next'

import { submitContactForm } from '@/services/api/contactEmail'

import type { ContactFormDataType } from '@/types/components/ContactForm'

export const useSubmitForm = () => {
  const { i18n } = useTranslation()

  const submit = async (formData: ContactFormDataType) => {
    try {
      return await submitContactForm({
        lang: i18n.language.split('-')[0],
        email: formData.step1.email || '',
        name: formData.step2.fullName || '',
        phone: formData.step3.phone || '',
        institution: formData.step4.institutionName || '',
        profession: formData.step4.profession?.label || ''
      })
    } catch (e) {
      throw e
    }
  }

  return { submit }
}
